import Icon from '../components/Icon.vue'

Icon.register({
  tasks: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M208 132H496C504.8 132 512 124.8 512 116V76C512 67.2 504.8 60 496 60H208C199.2 60 192 67.2 192 76V116C192 124.8 199.2 132 208 132zM208 292H496C504.8 292 512 284.8 512 276V236C512 227.2 504.8 220 496 220H208C199.2 220 192 227.2 192 236V276C192 284.8 199.2 292 208 292zM208 452H496C504.8 452 512 444.8 512 436V396C512 387.2 504.8 380 496 380H208C199.2 380 192 387.2 192 396V436C192 444.8 199.2 452 208 452zM64 368C37.5 368 15.4 389.5 15.4 416S37.5 464 64 464 112 442.5 112 416 90.5 368 64 368zM156.5 69L84.3 141.2 68.7 156.8C64 161.5 55.8 161.5 51.1 156.8L3.5 109.4C-1.2 104.7-1.2 97.1 3.5 92.4L19.2 76.7C23.9 72 31.5 72 36.2 76.7L58.9 98.8 122.6 35.5C127.3 30.8 134.9 30.8 139.6 35.5L156.6 52C161.2 56.7 161.2 64.3 156.5 69zM156.5 228.6L84.3 300.8 68.6 316.5C63.9 321.2 55.7 321.2 51 316.5L3.5 269C-1.2 264.3-1.2 256.7 3.5 252L19.2 236.3C23.9 231.6 31.5 231.6 36.2 236.3L58.9 258.4 122.6 194.7C127.3 190 134.9 190 139.6 194.7L156.6 211.7C161.2 216.3 161.2 223.9 156.5 228.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tasks.js
// module id = 2Pww
// module chunks = 144